module.exports = __webpack_public_path__ + "static/media/icono_encuesta.405e6dd7.svg";